/*
 * @Author: ken yang
 * @Date: 2022-10-31 13:37:42
 * @LastEditTime: 2022-12-28 16:58:57
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_admin/src/utils/request/index.js
 */
import axios from 'axios'
import useFixTime from './fixTime'
import useDelNullKey from './delNullKey'
// development
const baseURL = serveUrl
const instance = axios.create({
  baseURL: baseURL,
})

const noTokenUrls = [
  '/admin/user/eEiEY8U5SP11Glrv/login'
]

instance.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'

const okCode = 1
const needLoginCode = 50

useFixTime(instance)
useDelNullKey(instance)

// 添加请求拦截器
instance.interceptors.request.use(async (config) => {
  const userStore = useUserStore()
  const configStore = useConfigStore()
  const time = +new Date()
  config.headers.time = time
  config.headers.deviceType = 3
  const obj = fixTime(delNullKey(config.data || {}), '/')
  config.headers.signature = encrypt.requestSign(obj, time)
  config.headers.token = userStore.token || localStorage.token || ''
  config.headers.language = configStore.locale

  if (noTokenUrls.includes(config.url)) {
    delete config.headers.token
  }

  return config
})

instance.interceptors.response.use(
  (res) => {
    const userStore = useUserStore()
    const { config, data } = res

    if (data.code == needLoginCode) {
      ElMessage.error(data.message)
      userStore.logout()
      // winMes.postParent('updateToken', '')
      return Promise.reject(data)
    } else if (data.code != okCode) {
      ElMessage.error(data.message)
      return Promise.reject(data)
    }
    return res
  },
  async (error) => {
    const userStore = useUserStore()
    console.log('error', error)
    const response = error.response
    const httpCode = response.status
    if (httpCode != 200) {
      const errorText = $t('public.networkError')
      ElMessage.error(errorText)
      return Promise.reject(errorText)
    }

    return Promise.reject(error)
  }
)

const needLoginFilter = (cb) => {
  return (...age) => {
    const userStore = useUserStore()
    const url = age[0]
    if (needLoginUrl.includes(url) && isEmpty(userStore.token)) {
      throw new Error(`url:${url} 需要登录发送，已被拦截！`)
    }
    return cb(...age)
  }
}

instance.get = needLoginFilter(instance.get)
instance.post = needLoginFilter(instance.post)
instance.put = needLoginFilter(instance.put)
instance.patch = needLoginFilter(instance.patch)
instance.delete = needLoginFilter(instance.delete)

export default instance
